import { Grid, Button, MenuItem, FormControl, Select, ListItemText, ListItemIcon, Checkbox, Input } from '@mui/material'
import React, { useState,useMemo } from 'react'
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import { useDispatch, useSelector } from "react-redux";
import { setLogicalFilter } from "../../../reduxStore/reducer";
import { ListSubheader, TextField, InputAdornment } from "@mui/material";
import {  popValues, ageGroup, tierType, accountStatus, Category, residentType, dimensionNames, pfmType,teirCategory
} from "./logicalVals";
import reportbuilder from "../ReportBuilder.module.css";

const LogicalFiltersDropDown = () => {
  const dispatch = useDispatch();
  const selectedFilter = useSelector((state) => {
    return state.selectedDimensions.logicalFilter;
  });
  console.log("selectedFilter", selectedFilter);
  const [dimensions, setDimensions] = useState(" ");
  const [selectedVal, setSelectedVal] = useState([]);
  const [searchText, setSearchText] = useState("");

  // let type = null;
  let options = [];

  const handleChange = (event) => {
    console.log(event.target.value);
    setDimensions(event.target.value);
    setSelectedVal([]);
  };
  switch (dimensions) {
    case "POP":
      options = popValues;
      break;
    case "Age Group":
      options = ageGroup;
      break;
    case "Tier Type":
      options = tierType;
      break;
    case "Resident Type":
      options = residentType;
      break;
      case "Account Status" :
        options = accountStatus;
        break;
      case "Category" :
        options = Category;
        break;
      case "PFM" :  
         options = pfmType;
         break;
      case "Tier AUM Type":
        options = teirCategory;
        break;
  }
  const onSelectHandeler = () => {
    // need to store values in redux
    console.log("selected logical filter values", dimensions, selectedVal);
    // setFilterList( {
    //   ...filterList,
    //   [`${dimensions}`] : selectedVal
    // })
    dispatch(
      setLogicalFilter([
        {
          ...selectedFilter[0],
          [`${dimensions}`]: selectedVal,
        },
      ])
    );
    setDimensions("");
    setSelectedVal([]);
  };
  const handleMultipleChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelectedVal(selectedVal.length === options.length ? [] : options);
      return;
    }
    setSelectedVal(value);
  };
  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  console.log("containsText", containsText);
  let displayedOptions = useMemo(() => {
    let res = options?.filter((option) => containsText(option, searchText));
    return res;
  }, [searchText, options]);
  console.log("displayedOptions", displayedOptions);
  return (
    <Grid
      container
      xs={12}
      sx={{
        display: "flex",
        felxDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Grid xs={12} md={3}>
        <FormControl
          variant="standard"
          sx={{
            width: "100%",
            height: "100%",
            // minWidth: "10rem"
          }}
        >
          {/* <InputLabel id="demo-simple-select-standard-label">dimensions</InputLabel> */}
          <Select
            className={reportbuilder.logicForm}
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={dimensions}
            onChange={handleChange}
          >
            {dimensionNames?.map((item) => {
              console.log("inside", item);
              return (
                <MenuItem
                  value={item.name}
                  type="checkbox"
                >{`${item.name}`}</MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid xs={12} md={7}>
        <FormControl
          variant="standard"
          sx={{
            margin: "auto",
            width: "100%",
            height: "100%",
            // , minWidth: "22rem"
          }}
        >
        
            <Select 
              className={reportbuilder.logicForm}
              MenuProps={{ autoFocus: false }}
              labelId="demo-multiple-select-label"
              id="demo-multiple-select"
              multiple
              value={selectedVal}
              onChange={handleMultipleChange}
              onClose={() => setSearchText("")}
              renderValue={(selected) => `${selected.length} items selected`}
            >
                 <ListSubheader>
                <TextField
                  size="small"
                  // Autofocus on textfield
                  autoFocus
                  placeholder="Type to search..."
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {/* <SearchIcon /> */}
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key !== "Escape") {
                      e.stopPropagation();
                    }
                  }}
                />
              </ListSubheader>
              {displayedOptions.length == options.length ? (
                <MenuItem value="all">
                  <ListItemIcon>
                    <Checkbox
                      checked={
                        options?.length > 0 &&
                        selectedVal.length === options?.length
                      }
                      indeterminate={
                        selectedVal.length > 0 &&
                        selectedVal.length < options?.length
                      }
                    />
                  </ListItemIcon>
                  <ListItemText primary="Select All" />
                </MenuItem>
              ) : (
                <></>
              )}
              {displayedOptions?.map((option) => (
                <MenuItem key={option} value={option}>
                  <ListItemIcon>
                    <Checkbox checked={selectedVal.indexOf(option) > -1} />
                  </ListItemIcon>
                  <ListItemText primary={option} />
                </MenuItem>
              ))}
            </Select>
        </FormControl>
      </Grid>
      <Grid xs={12} md={1.8} sx={{ width: "100%", height: "100%" }}>
        <Button variant="contained" onClick={onSelectHandeler}>
          +
        </Button>
        {/* need to change the size of the button when responseive */}
      </Grid>
    </Grid>
  );
};

export default LogicalFiltersDropDown;
